import React from 'react';
import { Link } from 'react-router-dom';
import { FaServer, FaChartLine, FaMapMarkedAlt, FaShieldAlt } from 'react-icons/fa';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white font-bold text-3xl mx-auto mb-6 shadow-xl shadow-emerald-500/25">
          S
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-3">Station</h1>
        <p className="text-lg text-gray-500 mb-8">Monitoreo inteligente de estaciones de medición agrícola</p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {[
            { icon: FaServer, label: 'Terminales', desc: 'Gestión en tiempo real' },
            { icon: FaChartLine, label: 'Gráficos', desc: 'Visualiza tendencias' },
            { icon: FaMapMarkedAlt, label: 'Mapa', desc: 'Geolocalización' },
            { icon: FaShieldAlt, label: 'Seguro', desc: 'Datos protegidos' },
          ].map(({ icon: Icon, label, desc }) => (
            <div key={label} className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm">
              <Icon className="w-6 h-6 text-emerald-500 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-800">{label}</p>
              <p className="text-[10px] text-gray-400">{desc}</p>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4">
          <Link to="/login" className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-xl transition-colors shadow-lg shadow-emerald-500/25 text-sm">
            Iniciar Sesión
          </Link>
          <Link to="/register" className="px-6 py-3 bg-white hover:bg-gray-50 text-gray-700 font-medium rounded-xl border border-gray-200 transition-colors text-sm">
            Registrarse
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
